import { Translation } from 'cng-common/features/translations/components/translation'

import styles from './DisplayRejectionReason.module.scss'

export enum RejectionReasonTranslationKey {
  RequestWasRejected = 'bpreg-regect-text',
  CountryIsNotEligible = 'bpreg-reject-country-is-not-eligible',
  CompanyNotConfirmed = 'bpreconfirm_not_my_company',
  EmailNotRegistered = 'bpreconfirm_email_used_not_eligile',
  EmailIsEligibleToBuy = 'spr_alr_eligible',
  EmailIsNotEligible = 'spr_is_not_eligible',
}

const checkReasonKey = (key: RejectionReasonTranslationKey | string) => {
  return Object.values<string>(RejectionReasonTranslationKey).includes(key)
    ? key
    : RejectionReasonTranslationKey.RequestWasRejected
}

const rejectReasons = (text: string, t: (key: string) => string) => {
  if (text === RejectionReasonTranslationKey.CompanyNotConfirmed) {
    return (
      <div>
        {t('bpreconfirm_not_my_company_thank_you')}
        <br />
        {t('bpreconfirm_not_my_company_check_info')}
        <br />
        {t('bpreconfirm_regards_thank_you')}
        <span>,</span>
        {t('bpreconfirm_team_name')}
      </div>
    )
  }
  if (text === RejectionReasonTranslationKey.EmailNotRegistered) {
    return (
      <div>
        {t('bpreconfirm_email_used_not_eligile')}
        <br />
        {t('bpreconfirm_email_used_not_eligile_use_invite_email')}
        <br />
        {t('bpreconfirm_regards_thank_you')}
        <span>,</span>
        {t('bpreconfirm_team_name')}
      </div>
    )
  }
  if (text === RejectionReasonTranslationKey.EmailIsEligibleToBuy) {
    return (
      <div>
        {t('spr_alr_eligible')}
        <br />
        {t('spr_regards_thank_you')}
        <span>,</span>
        {t('spr_team_name')}
      </div>
    )
  }
  if (text === RejectionReasonTranslationKey.EmailIsNotEligible) {
    return (
      <div>
        {t('spr_is_not_eligible')}
        <br />
        {t('spr_regards_thank_you')}
        <span>,</span>
        {t('spr_team_name')}
      </div>
    )
  }
  const defaultReason = RejectionReasonTranslationKey.RequestWasRejected
  return t(defaultReason)
}

const rejectReasonsWithTranslationComponent = (transitionName: string) => {
  if (transitionName === RejectionReasonTranslationKey.CompanyNotConfirmed) {
    return (
      <div>
        <Translation text="bpreconfirm_not_my_company_thank_you" />
        <br />
        <Translation text="bpreconfirm_not_my_company_check_info" />
        <br />
        <Translation text="bpreconfirm_regards_thank_you" span />
        <span>,</span>
        <Translation text="bpreconfirm_team_name" />
      </div>
    )
  }
  if (transitionName === RejectionReasonTranslationKey.EmailNotRegistered) {
    return (
      <div>
        <Translation text="bpreconfirm_email_used_not_eligile" />
        <br />
        <Translation text="bpreconfirm_email_used_not_eligile_use_invite_email" />
        <br />
        <Translation text="bpreconfirm_regards_thank_you" span />
        <span>,</span>
        <Translation text="bpreconfirm_team_name" />
      </div>
    )
  }
  if (transitionName === RejectionReasonTranslationKey.EmailIsEligibleToBuy) {
    return (
      <div>
        <Translation text="spr_alr_eligible" />
        <br />
        <Translation text="spr_regards_thank_you" span />
        <span>,</span>
        <Translation text="spr_team_name" />
      </div>
    )
  }
  if (transitionName === RejectionReasonTranslationKey.EmailIsNotEligible) {
    return (
      <div>
        <Translation text="spr_is_not_eligible" />
        <br />
        <Translation text="spr_regards_thank_you" span />
        <span>,</span>
        <Translation text="spr_team_name" />
      </div>
    )
  }
  return <Translation text={checkReasonKey(transitionName)} span htmlAvailable />
}

export const DisplayRejectionReason = ({
  text,
  t,
}: {
  text: RejectionReasonTranslationKey | string
  t?: (key: string) => string
}) => {
  if (t) {
    return (
      <div className={styles.completed_dialog__content}>
        <div className={styles.completed_dialog__header}>
          <p className={styles.text_center}>{rejectReasons(text, t)}</p>
        </div>
      </div>
    )
  }

  return (
    <div className={styles.completed_dialog__content}>
      <div className={styles.completed_dialog__header}>
        <p className={styles.text_center}>{rejectReasonsWithTranslationComponent(text)}</p>
      </div>
    </div>
  )
}
